import React from 'react';

export const SkeletonLoader = () => {
  return (
    <div>
      <div className="w-100">
        <div className="mb-16px p-16px p-md-20px border-radius-md-12 animate" style={{ height: 400 }}></div>
      </div>
    </div>
  );
};

export const ChartSkeleton = () => {
  return (
    <div className="w-100">
      <div className="mb-16px mt-24px mx-24px border-radius-md-12 animate" style={{ height: 340 }}></div>
    </div>
  );
};
